export const firebaseConfigRegion = {
  /**
   * Region where GCP functions are deployed to
   */
  gcpRegionFunctions: 'europe-west1',
};
